type StreetAddress = {
  street?: string | null;
  unitNumber?: string | null;
};

export const formatStreetLine = ({ street, unitNumber }: StreetAddress): string => {
  const house = street?.trim() ?? '';
  const unit = unitNumber?.trim() ?? '';
  if (!house) return unit;
  if (!unit || house.split(/\s+/, 1)[0] === unit) return house;
  return `${house} ${unit}`;
};
